<template>
  <b-modal
    ref="modal"
    :title="isDuplicates ? 'Convert / Replace or upload as new file:' : 'Convert:'"
    centered
    @hide="closeHandler"
  >
    <p 
      v-if="isDuplicates" 
      class="mt-2"
    >
      One or more items already exists in this location. 
      Do you want to replace the existing items with a new version or keep both items?
    </p>

    <ul
      v-if="isDuplicates"
      class="text-break"
    >
      <li
        v-for="file in payload.files"
        :key="file.id"
      >
        {{ file?.name }}
      </li>
    </ul>

    <b-form-group v-if="isDuplicates">
      <b-form-radio
        v-model="selected"
        :value="1"
      >
        Replace existing items
      </b-form-radio>
      <b-form-radio
        v-model="selected"
        :value="2"
      >
        Keep all items
      </b-form-radio>
      <b-form-radio
        v-model="selected"
        :value="3"
      >
        Stop
      </b-form-radio>
    </b-form-group>
    
    <b-form-checkbox
      v-model="isRemoveBackground"
      :value="true"
      :unchecked-value="false"
    >
      Remove background
    </b-form-checkbox>

    <b-form-checkbox
      v-model="isCropToImage"
      :value="true"
      :unchecked-value="false"
    >
      Crop to image
    </b-form-checkbox>
    
    <template #modal-footer>
      <ButtonOutline
        variant="outline-primary"
        @click="handleHide"
      >
        Cancel
      </ButtonOutline>

      <ButtonPrimary
        v-if="selected === 3"
        variant="primary"
        @click="handleHide"
      >
        Ok
      </ButtonPrimary>

      <ButtonPrimary 
        v-else
        variant="primary"
        @click="handleClick"
      >
        Upload
      </ButtonPrimary>
    </template>
  </b-modal>
</template>

<script>
import mixinModal from './mixin';
import ButtonPrimary from "@frontend/components/common/atoms/ButtonPrimary.vue";
import ButtonOutline from "@frontend/components/common/atoms/ButtonOutline.vue";
import { createNamespacedHelpers } from "vuex";
import { ACTIONS } from "@frontend/store/file-browser";

const {
  mapActions,
  mapGetters
} = createNamespacedHelpers('fileBrowser')

export default {
  name: 'UploadProductFilesModal',
  
  components: {ButtonOutline, ButtonPrimary},
  
  mixins: [
    mixinModal
  ],

  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  
  data: () => ({
    selected: 2,
    isRemoveBackground: false,
    isCropToImage: false
  }),

  computed: {
    ...mapGetters(['isDuplicates']),
  },
  
  methods: {
    ...mapActions([ACTIONS.UPLOAD_PRODUCT_FILES, 'hideModal']),
    
    handleClick() {
      this[ACTIONS.UPLOAD_PRODUCT_FILES]({
        files: this.payload.files,
        isRemoveBackground: this.isRemoveBackground,
        isCropToImage: this.isCropToImage,
        selected: this.selected,
      });
      
      this.$refs.modal.hide();
    },

    handleHide() {
      this.$refs.modal.hide();
      this.hideModal({});
    },
    
  }
}
</script>

<style lang="scss" scoped>

</style>
